export const msalConfig = {
  auth: {
    clientId: "0172edb8-162b-4374-887d-41ff41b4b845",
    authority: "https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1/v2.0/",
    redirectUri: "https://portalacc.oi.rabobank.nl",
  },
};

export const loginRequest = {
  scopes: ["https://portal2acc.oi.rabobank.nl/user_impersonation"], 
};
